import e from"styled-components";const o=e.div`
	position: relative;
	border-radius: 83.333px;
	border: 0.833px solid ${({theme:e})=>e.border.black10};
	background: ${({theme:e})=>e.bg.secondary};

	display: flex;
	align-items: center;
	gap: 5px;

	cursor: ${({isClickable:e})=>e?"pointer":"default"};

	padding: 5px;
	outline: ${({isSelected:e,isClickable:o,theme:r})=>e&&o?`2.5px solid ${r.border.brand}`:"none"};
`,r=e.div`
	width: 26.667px;
	height: 26.667px;
	aspect-ratio: 1/1;
	border-radius: 13.333px;
	border: 0.833px solid ${({theme:e})=>e.border.black15};
	background: ${({backgroundColor:e})=>e};
	color: ${({color:e})=>e};

	text-align: center;
	font-family: "SF Pro Display";
	font-size: 11.667px;
	font-style: normal;
	font-weight: 600;

	display: grid;
	place-content: center;
`;export{r as PaletteColor,o as PaletteContainer};
